import './index.sass';
import axios from "axios";

export default () => {
  const $root = $('.feeds');
  const $btn = $('.js-load-feeds');

  $btn.on('click', function (e) {
    e.preventDefault();
    const $el = $(this);
    initAjax($el);
  });

  const initAjax = ($el) => {
    if(!$el.data('url')) $el.hide();
    $root.find('.feeds__list').append('<div class="list-loader"></div>');
    axios.get($el.data('url'), {
      headers: { 'Accept': 'application/json' }
    }).then((response) => {
      const resp = response;
      const $feeds = $(resp.data.items);
      const url = resp.data.url;
      if(url) {
        $el.data('url', url);
      } else {
        $el.remove();
      }
      $root.find('.feeds__list').append($feeds);
      $root.find('.list-loader').remove();
      if(resp.data.pagination) {
        $root.find('.feeds__pagination').html(resp.data.pagination);
      }
    }).catch((error) => {
      console.log(error.response)
    });
  }

}